let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lLdwH")).then(() => parcelRequire('5prwP'));